<template>
  <ul class="search-filter">
    <li :class="{ 'is-active': !value }" @click="$emit('input', null)">
      <div>All</div>
      <div v-if="count === 0">-</div>
      <global-search-number v-else :number="count"></global-search-number>
    </li>
    <li
      v-for="type in types"
      :key="type.key"
      :class="{
        'is-active': value && value.key === type.key,
        'is-disabled': typeCount[type.key] == 0
      }"
      @click="$emit('input', type)"
    >
      <div>{{ type.label }}</div>
      <div v-if="count === 0">-</div>
      <global-search-number
        v-else
        :number="typeCount[type.key]"
      ></global-search-number>
    </li>
  </ul>
</template>

<script>
import GlobalSearchNumber from '@/components/search/GlobalSearchNumber'

export default {
  components: {
    GlobalSearchNumber
  },
  props: {
    value: Object,
    results: Array
  },
  data() {
    return {
      types: [
        { key: 'article', label: 'News' },
        { key: 'event', label: 'Events' },
        { key: 'startup_import', label: 'Startups' },
        { key: 'page', label: 'Pages' }
      ]
    }
  },
  computed: {
    count() {
      return this.results.length
    },
    typeCount() {
      return this.results.reduce(
        (count, result) => {
          count[result.type]++

          return count
        },
        { article: 0, event: 0, startup_import: 0, page: 0 }
      )
    }
  }
}
</script>
